export default "__VITE_ASSET__CMeH54dK__"